import { render, staticRenderFns } from "./SuggestedTime.vue?vue&type=template&id=6417313a&scoped=true&"
import script from "./SuggestedTime.vue?vue&type=script&lang=js&"
export * from "./SuggestedTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6417313a",
  null
  
)

export default component.exports